import { Banner } from '@fourthwall/components';
import React from 'react';
import { PaymentMethodsList } from '../../components/PaymentMethodsList/PaymentMethodsList';
import * as S from './ShopPaymentMethodsView.styled';
export const ShopPaymentMethodsView = ({ paymentMethodsProps, errorBanner, }) => (React.createElement("div", null,
    errorBanner && (React.createElement(S.BannerContainer, null,
        React.createElement(Banner, { appearance: "danger" }, errorBanner))),
    React.createElement(PaymentMethodsList, { paymentMethods: paymentMethodsProps })));
